<template>
  <b-modal
    ref="department-list"
    centered
    hide-header
    hide-footer
    hide-header-close
    body-class="phone-list-body p-0 text-dark"
    content-class="phone-list-modal"
    data-test-id="phone-list-modal"
  >
    <strong class="d-block mt-3 text-center font-bigger" data-test-id="phone-list-hospital-name">
      {{ hospitalName }}
    </strong>
    <div v-if="nonTwiageHospital" class="text-center font-bigger">Call only. No case data will be sent.</div>
    <div class="p-1 pl-3 mt-2 text-left phone-list__choose-department">Choose Department</div>

    <b-list-group class="w-100">
      <b-list-group-item
        v-for="item in phoneNumbers"
        :key="item.phoneNumber"
        class="phone-list__item pl-3 border-top-0 border-left-0 border-right-0 border-bottom"
        data-test-id="phone-list-item"
        @click="startCall(item)"
      >
        <h5 class="d-block text-left font-weight-bold">{{ item.name }}</h5>
        <span class="text-muted font-bigger">{{ item.phoneNumber }}</span>
      </b-list-group-item>
    </b-list-group>
  </b-modal>
</template>

<script>
const REF_NAME = "department-list";

export default {
  name: "DepartmentList",
  props: {
    phoneNumbers: {
      required: true,
      type: Array,
    },
    hospitalName: {
      type: String,
    },
    nonTwiageHospital: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    startCall(department) {
      this.$emit("startCall", department);
      this.hide();
    },
    show() {
      this.$refs[REF_NAME].show();
    },
    hide() {
      this.$refs[REF_NAME].hide();
    },
  },
};
</script>

<style lang="scss" scoped>
.phone-list-body {
  background-color: #fff;
  border: 1px solid #cbcbcb;
  border-radius: 10px;
}

.phone-list-modal {
  border-radius: 10px;
  color: #575757;
}

.phone-list__choose-department {
  background: #eeeeee;
}

.text-dark {
  color: #575757;
}

.font-bigger {
  font-size: 1.2em;
}

.phone-list__item:active,
.phone-list__item:hover {
  background-color: #dddddd;
  fill-opacity: 0.8;
}
</style>
